import React from 'react';
import Modal from './Modal';
import Button from './Button';
import './ConfirmDialog.css';

/**
 * Diálogo de confirmação estilizado — substitui window.confirm nativo.
 *
 * Props:
 *  - open: controla a exibição
 *  - title / message: título e corpo (message preserva quebras de linha via CSS)
 *  - confirmLabel / cancelLabel: textos dos botões
 *  - confirmVariant: variante do Button do botão de confirmar ('primary' | 'danger' | ...)
 *  - onConfirm: ação do botão de confirmar
 *  - onCancel: ação do botão de cancelar (ação "negativa" explícita)
 *  - onClose: fechar pelo X / clique fora (default = onCancel). Passe algo distinto
 *    quando fechar sem agir for diferente de cancelar.
 */
function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
  onClose,
}) {
  if (!open) return null;
  const fechar = onClose || onCancel;
  return (
    <Modal onClose={fechar} className="cw-confirm">
      <button type="button" className="cw-confirm-close" onClick={fechar} aria-label="Fechar">
        ×
      </button>
      {title && <h3 className="cw-confirm-title">{title}</h3>}
      {message && <div className="cw-confirm-message">{message}</div>}
      <div className="cw-confirm-actions">
        <Button variant="secondary" onClick={onCancel}>{cancelLabel}</Button>
        <Button variant={confirmVariant} onClick={onConfirm}>{confirmLabel}</Button>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
